import React, { useContext, useEffect, useState } from 'react';
import { history } from '../../utils/history';

import { Router, Routes, Route, Navigate, Link } from 'react-router-dom';

import { observer } from 'mobx-react';

import { Login } from '../../routes/UserAccount/Login';
import { LandingPage } from '../../routes/LandingPage';
import AuthStore from '../../store/AuthStore';
import { Home } from '../../routes/Home';
import { Status } from '../../routes/Status';
import { UserManagement } from '../../routes/UserManagement';
import { WorkflowStages } from '../../routes/WorkflowStages';
import { ForgotPassword } from '../../routes/UserAccount';

export const AppRouter = observer(({}) => {
  return (
    <>
      <Routes>
        <Route path="/login" element={AuthStore.isAuthenticated ? <Navigate to="/home" /> : <Login />} />
        <Route
          path="/forgot-password"
          element={AuthStore.isAuthenticated ? <Navigate to="/home" /> : <ForgotPassword />}
        />
        <Route path="/" element={AuthStore.isAuthenticated ? <Navigate to="/home" /> : <LandingPage />} />
        <Route path="/home" element={AuthStore.isAuthenticated ? <Home /> : <Navigate to="/login" />} />
        <Route path="/status" element={AuthStore.isAuthenticated ? <Status /> : <Navigate to="/login" />} />
        <Route
          path="/user-management"
          element={AuthStore.isAuthenticated ? <UserManagement /> : <Navigate to="/login" />}
        />
        <Route
          path="/workflow-stages"
          element={AuthStore.isAuthenticated ? <WorkflowStages /> : <Navigate to="/login" />}
        />
      </Routes>
    </>
  );
});
